

/**
 * Append a note about how a policy change propagated to existing artefacts. The
 * blocking/unblocking is applied immediately server-side; rescan only covers rego
 * re-derivation and may be coalesced behind a recent fan-out.
 *
 * Exported because the Policies overview applies baselines too, and the same event has to read
 * the same way wherever it is reported.
 */
export function rescanNote(rescan?: string): string {
  if (rescan === 'queued') return ' Existing versions are being re-scanned to apply it.'
  if (rescan === 'coalesced') return ' A re-scan was triggered recently; this change is queued and will be applied within the hour.'
  return ''
}

